import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { SignedDocumentService } from 'src/app/services/signed-document.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-signed-document-file-download-modal',
  standalone: false,
  templateUrl: './signed-document-file-download-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './signed-document-file-download-modal.component.less'
})
export class SignedDocumentFileDownloadModalComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private ToastService: ToastService,
    private SignedDocumentService: SignedDocumentService,
    private ActiveModal: NgbActiveModal
  ) {}

  SignedDocumentId?: number;
  PreSignedUrls: { filename: string; presignedUrl: string }[] = [];

  close() {
    this.ActiveModal.close();
  }

  downloadS3File({ presignedUrl }: { presignedUrl: string }) {
    saveAs(presignedUrl);
  }

  ngOnInit(): void {
    if (!this.SignedDocumentId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing SignedDocumentId.',
        { returnError: true }
      );
    }

    this.SignedDocumentService.getS3PreSignedUrls({
      id: this.SignedDocumentId
    }).subscribe({
      next: (PreSignedUrls) => {
        this.PreSignedUrls.push(...PreSignedUrls);
        this._cdr.markForCheck();
      }
    });
  }
}
